import React from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import axios from "axios";
import constant from "../../constant";
import Page404 from "../Page404";

import "./style.scss";

export default class HaveDesk extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stage_index: 1,
      spaceId: "",
      listing: "",
      isLogin: false,
      user_id: ""
    };
  }

  componentDidMount() {
    let _this = this;
    let match = this.props.match;
    let spaceId = match.params.id;

    let O_Auth = JSON.parse(localStorage.getItem("O_Auth"));

    if (O_Auth && O_Auth["id"] !== "") {
      this.setState({
        isLogin: true,
        user_id: O_Auth["id"]
      });
    }

    if (match.path === "/have-desk/edit/:id") {
      if (O_Auth && O_Auth["id"] !== "") {
        axios
          .get(`${constant.phpHost}action/listing.php`, {
            params: {
              todo: "decode_list_id",
              space_id: spaceId
            }
          })
          .then(res => {
            _this.setState({
              spaceId: res.data,
              listing: "edit"
            });
          })
          .catch(error => {
            // console.log("error");
          });
      } else {
        window.location.href = "/";
      }
    } else {
      _this.setState({
        spaceId,
        listing: "add"
      });
    }
  }

  renderSwitch(stage_index, spaceId) {
    let { isLogin, listing, user_id } = this.state;

    switch (stage_index) {
      case 1:
        return (
          <Step1
            stepButton={this.stepButton}
            spaceId={spaceId}
            isLogin={isLogin}
            listing={listing}
          />
        );
      case 2:
        return (
          <Step2
            stepButton={this.stepButton}
            spaceId={spaceId}
            isLogin={isLogin}
            listing={listing}
          />
        );
      case 3:
        return (
          <Step3
            stepButton={this.stepButton}
            spaceId={spaceId}
            listing={listing}
            user_id={user_id}
          />
        );
      case 4:
        return (
          <Step4
            stepButton={this.stepButton}
            spaceId={spaceId}
            listing={listing}
          />
        );
      case 5:
        return (
          <Step5
            stepButton={this.stepButton}
            spaceId={spaceId}
            isLogin={isLogin}
            listing={listing}
          />
        );
      default:
        return <Page404 />;
    }
  }

  stepButton = index => {
    window.scrollTo(0, 0);

    this.setState({
      stage_index: index
    });
  };

  render() {
    const { stage_index, spaceId } = this.state;

    const stages = [
      {
        id: 1,
        image: "/assets/images/multi_pic.jpg",
        title: "Add Photos",
        description:
          "Please add at least 3 photos of your workspace in order to get your proper onboarding.",
        tip:
          "<i> Tip: Always take photos vertically, for the best experience.</i>"
      },
      {
        id: 2,
        image: "/assets/images/multi_pic.jpg",
        title: "Add Videos",
        description:
          "Please add videos of your workspace in order to get your proper onboarding.",
        tip:
          "<i> Tip: Always take videos greater than 720p for best quality.</i>"
      },
      {
        id: 3,
        image: "/assets/images/about.png",
        title: "Add a good description",
        description:
          "Don't let the customer imagine, let them know how good your space is.",
        tip:
          "<i> Tip: Try to keep the description of your spaces as exact and inviting as possible. In this way, the expectations of your space are met.</i>"
      },
      {
        id: 4,
        image: "/assets/images/about.png",
        title: "Discount price",
        description: "Attracting customer using for discount price.",
        tip: "<i> Tip: Always helpfull to the customer interaction.</i>"
      },
      {
        id: 5,
        image: "/assets/images/review.jpg",
        title: "Review your listing",
        description:
          "check if all your information is correct and matches your space.",
        tip:
          '<i> Tip: if you want to edit any information? <br/> please click on the <b class="color_red"> previous step</b>.</i>'
      }
    ];

    const get_listing =
      spaceId !== "" ? JSON.parse(localStorage.getItem(spaceId)) : null;
    const isLongterm = get_listing ? get_listing["isLongterm"] : false;

    return (
      <div className="add_space">
        <div className="left" id="havedesk_tab">
          <div className="stages">
            <b className={stage_index === 1 ? "active" : ""}>1</b>
            <b className={stage_index === 2 ? "active" : ""}>2</b>
            <b className={stage_index === 3 ? "active" : ""}>3</b>
            {!isLongterm ? (
              <b className={stage_index === 4 ? "active" : ""}>4</b>
            ) : null}
            <b className={stage_index === 5 ? "active" : ""}>
              {!isLongterm ? "5" : "4"}
            </b>
          </div>

          {stages.map((stage, i) =>
            stage_index === stage.id ? (
              <div className="stage_content" key={i}>
                <div>
                  <img src={stage.image} alt="" />
                </div>
                <div>
                  <b>{stage.title}</b>
                </div>
                <div dangerouslySetInnerHTML={{ __html: stage.description }} />
                <div dangerouslySetInnerHTML={{ __html: stage.tip }} />
              </div>
            ) : null
          )}
        </div>

        <div className="right">
          {spaceId !== "" ? this.renderSwitch(stage_index, spaceId) : null}
        </div>
      </div>
    );
  }
}
